// src/stores/appStore.js
import { defineStore } from "pinia";

export const useAppStore = defineStore("appStore", {
  state: () => ({
    isLoading: false,
  }),

  actions: {
    setLoading(status) {
      this.isLoading = status;
    },
  },
});
